import {
  AtsRejectionReasonsListDocument,
  CreateRejectionReasonDocument,
  CreateRejectionReasonMutation,
  CreateRejectionReasonMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateRejectionReason = () => {
  const [createRejectionReason, { loading }] = useMutation(CreateRejectionReasonDocument, {
    extractorFn: (data: CreateRejectionReasonMutation) =>
      data.atsMutations.createAtsRejectionReason,
  })

  return {
    loading,
    create(variables: CreateRejectionReasonMutationVariables) {
      return createRejectionReason({
        variables,
        refetchQueries: [AtsRejectionReasonsListDocument],
      })
    },
  }
}
